import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaArrowUp,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import logo from "../image/Gplus Icon (1).webp";

const Footer = () => {
  const year = new Date().getFullYear();

  const companyLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about-us" },
    { name: "Contact Us", path: "/contact-us" },
    { name: "Service & Support", path: "/complaint/new" },
  ];

  const supportLinks = [
    { name: "Privacy Policy", path: "/privacy-policy" },
    { name: "Terms & Conditions", path: "/terms-conditions" },
    { name: "Return & Refunds", path: "/return-refunds" },
    { name: "Disclaimer", path: "/disclaimer" },
  ];

  const socialLinks = [
    {
      name: "Facebook",
      href: "https://www.facebook.com/gplushomeappliances/",
      icon: <FaFacebookF />,
      className: "bg-[#1877F2]",
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/gplus.india?utm_source=qr&igsh=MWFzZGh3dXl2bWk0cA%3D%3D",
      icon: <FaInstagram />,
      className: "bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737]",
    },
    {
      name: "Twitter",
      href: "https://twitter.com/GplusHome",
      icon: <FaTwitter />,
      className: "bg-[#111111]",
    },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/company/gplus-india-home-appliances/",
      icon: <FaLinkedinIn />,
      className: "bg-[#0A66C2]",
    },
    {
      name: "YouTube",
      href: "https://www.youtube.com/@gplushomeappliances",
      icon: <FaYoutube />,
      className: "bg-[#FF0000]",
    },
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="relative overflow-hidden bg-[#F4E9D8] text-[#2B211E]">
      {/* =========================================================
          SUBTLE CREAM TEXTURE
      ========================================================= */}

      <div
        className="pointer-events-none absolute inset-0 opacity-50"
        style={{
          backgroundImage: `
            radial-gradient(
              circle at 15% 20%,
              rgba(255,255,255,0.75) 0,
              transparent 28%
            ),
            radial-gradient(
              circle at 85% 80%,
              rgba(116,28,37,0.06) 0,
              transparent 30%
            )
          `,
        }}
      />

      {/* =========================================================
          TOP BRAND INTRO
      ========================================================= */}

      <div className="relative border-b border-[#6B1820]/10">
        <div className="mx-auto max-w-[1440px] px-4 py-5 sm:px-4 sm:py-6 lg:px-5 lg:py-7">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
            {/* LEFT */}

            <div className="max-w-3xl">
              <div className="mb-4 flex items-center gap-3">
                <span className="h-[2px] w-8 bg-[#711923]" />

                <span className="text-[9px] font-bold uppercase tracking-[0.3em] text-[#711923]">
                  Gplus Home Appliances
                </span>
              </div>

              <h2 className="text-3xl font-semibold leading-[1.08] tracking-[-0.035em] text-[#30221E] sm:text-4xl lg:text-[3.2rem]">
                Designed for modern homes.
                <span className="block text-[#711923]">
                  Made for everyday living.
                </span>
              </h2>

              <p className="mt-4 max-w-2xl text-sm leading-6 text-[#25201d] sm:text-base">
                Thoughtfully designed appliances that bring comfort, convenience
                and modern functionality into everyday life.
              </p>
            </div>

            {/* RIGHT CONTACT */}

            <div className="flex flex-col gap-3 border-l-2 border-[#711923] pl-5 sm:pl-6 lg:min-w-[300px]">
              <p className="text-[14px] font-bold uppercase tracking-[0.25em] text-[#f42b15]">
                Customer Care
              </p>

              <a
                href="tel:1800123986666"
                className="group flex items-center gap-3 text-sm font-semibold text-[#3A2924] transition hover:text-[#711923]"
              >
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#711923] text-white">
                  <FaPhoneAlt size={11} />
                </span>
                1800 12398 6666
              </a>

              <a
                href="mailto:care@gplusindia.com"
                className="group flex items-center gap-3 text-sm font-medium text-[#27211e] transition hover:text-[#711923]"
              >
                <span className="flex h-8 w-8 items-center justify-center rounded-full border border-[#711923]/20 text-[#711923]">
                  <FaEnvelope size={11} />
                </span>
                care@gplusindia.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* =========================================================
          MAIN MAROON FOOTER
      ========================================================= */}

      <div className="relative overflow-hidden bg-gradient-to-br from-[#9f0214] via-[#a71501] to-[#7b0210] text-[#FFF8ED]">
        {/* Very subtle texture */}

        <div
          className="pointer-events-none absolute inset-0 opacity-30"
          style={{
            backgroundImage: `
              radial-gradient(
                circle at 10% 30%,
                rgba(255,255,255,0.06) 0,
                transparent 25%
              ),
              radial-gradient(
                circle at 90% 70%,
                rgba(224,185,126,0.08) 0,
                transparent 25%
              )
            `,
          }}
        />

        <div className="relative mx-auto max-w-[1440px] px-4 py-6 sm:px-4 sm:py-7 lg:px-5 lg:py-8">
          <div className="grid grid-cols-2 gap-x-8 gap-y-10 md:grid-cols-4 lg:gap-14">
            {/* =================================================
                BRAND
            ================================================= */}

            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl  text-[#68141D]">
                  {/* <span className="text-lg font-black">G</span> */}
                  <img src={logo} alt="Gplus Logo" />
                </div>

                <div>
                  <p className="text-xl font-bold uppercase tracking-[0.15em]">Gplus</p>

                  <p className="mt-0.5 text-[12px] font-bold uppercase tracking-[0.28em] text-[#ffbf65]">
                    Home Appliances
                  </p>
                </div>
              </div>

              <p className="mt-5 max-w-[250px] text-sm leading-6 text-[#ffffff]">
                Bringing thoughtful design and everyday convenience into modern
                Indian homes.
              </p>
            </div>

            {/* =================================================
                COMPANY
            ================================================= */}

            <div>
              <p className="text-[12px] font-bold uppercase tracking-[0.25em] text-[#fac67c]">
                Company
              </p>

              <div className="mt-1 h-px w-24 bg-[#f98e0a]" />

              <ul className="mt-5 space-y-3">
                {companyLinks.map((link) => (
                  <li key={link.path}>
                    <NavLink
                      to={link.path}
                      className={({ isActive }) =>
                        `text-[13px] transition-colors duration-300 ${
                          isActive
                            ? "font-semibold text-white"
                            : "text-[#ffffff] hover:text-yellow-500"
                        }`
                      }
                    >
                      {link.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* =================================================
                SUPPORT
            ================================================= */}

            <div>
              <p className="text-[12px] font-bold uppercase tracking-[0.25em] text-[#fac67c]">
                Support
              </p>

              <div className="mt-1 h-px w-24 bg-[#f98e0a]" />

              <ul className="mt-5 space-y-3">
                {supportLinks.map((link) => (
                  <li key={link.path}>
                    <NavLink
                      to={link.path}
                      className="text-[13px] text-[#fdfdfd] transition-colors duration-300 hover:text-yellow-500"
                    >
                      {link.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>

            {/* =================================================
                FOLLOW US — ONLY ONE SOCIAL SECTION
            ================================================= */}

            <div>
              <p className="text-[12px] font-bold uppercase tracking-[0.25em] text-[#fac67c]">
                Follow Us
              </p>

              <div className="mt-1 h-px w-24 bg-[#f98e0a]" />

              <h3 className="mt-5 text-lg font-semibold tracking-[-0.02em] text-white">
                Stay connected.
              </h3>

              <p className="mt-2 max-w-[230px] text-sm leading-6 text-[#ffffff]">
                Follow Gplus for product updates and new launches.
              </p>

              {/* SOCIAL ICONS — ONE TIME ONLY */}

              <div className="mt-5 flex flex-wrap gap-2">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Gplus ${social.name}`}
                    title={social.name}
                    className={`flex h-9 w-9 items-center justify-center rounded-full text-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${social.className}`}
                  >
                    {React.cloneElement(social.icon, {
                      size: 14,
                    })}
                  </a>
                ))}
              </div>
            </div>
          </div>

          
        </div>
      </div>

      {/* =========================================================
          BOTTOM BAR
      ========================================================= */}

      <div className="relative bg-gradient-to-r from-[#f9ddae] via-[#efde8b] to-[#fbfd89]">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-4 lg:px-4">
          <div className="flex flex-col gap-2 py-2 sm:py-2 md:flex-row md:items-center md:justify-between">
            <p className="hidden text-[9px] font-bold uppercase tracking-[0.22em] text-[#0b0a09] lg:block">
              Home Appliances · Everyday Living
            </p>
            <p className="text-center text-[10px] text-[#000000] sm:text-[11px] md:text-left">
              © {year} GplusIndia. All rights reserved.
            </p>

            <button
              type="button"
              onClick={scrollToTop}
              aria-label="Back to top"
              className="mx-auto flex h-9 w-9 items-center justify-center rounded-full bg-[#68141D] text-white transition-all duration-300 hover:-translate-y-1 hover:bg-[#4B0C13] md:mx-0"
            >
              <FaArrowUp size={11} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
